// Unpublished Work © 2021-2022 Deere & Company

import t from 'tcomb';

export const KeyNamePair = t.struct({
    key: t.String,
    name: t.String
});
